<script>
import { ref, onMounted, toRefs, watch, computed, reactive } from "vue";
import { useScrollEffect } from "../functions";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop", "nowFeature", "isOpen"],
	emits: ["changeContentStatus", "changeShowIndex"],
	setup(props, { emit }) {
		const { windowWidth, windowHeight, scrollTop, nowFeature } = toRefs(
			props
		);

		const container = ref(null);
		const imgA = ref(null);
		const imgB = ref(null);
		const mainTitle = ref(null);
		const cover = ref(null);
		const featuresA = ref(null);
		const featuresB = ref(null);
		const featureA1 = ref(null);
		const featureA2 = ref(null);
		const featureB1 = ref(null);
		const featureB2 = ref(null);

		const containerHeight = ref(0);
		const imgSrcA = reactive({
			pc: require("../assets/launchImg/background_c4-1.jpg"),
			mobile: require("../assets/launchImg/background_c4-1_mobile.png"),
		});
		const imgSrcB = reactive({
			pc: require("../assets/launchImg/background_c4-2.jpg"),
			mobile: require("../assets/launchImg/background_c4-2_mobile.jpg"),
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});

		const fadeInCoeff = useScrollEffect(
			-0.2 * windowHeight.value,
			0.4 * windowHeight.value,
			-0.5,
			1.1
		);
		const fadeOutCoeff = useScrollEffect(
			1 * windowHeight.value,
			1.6 * windowHeight.value,
			-1.1,
			1.1
		);
		const textCoeff = computed(() => {
			return useScrollEffect(
				1.3 * windowHeight.value,
				1.6 * windowHeight.value,
				-0.5,
				1.1
			);
		});
		const imgCoeff = computed(() => {
			return useScrollEffect(
				2.0 * windowHeight.value,
				2.6 * windowHeight.value,
				-1.1,
				1.1
			);
		});
		const zoomCoeff = computed(() => {
			return useScrollEffect(
				0 * windowHeight.value,
				2.3 * windowHeight.value,
				1,
				1.05
			);
		});
		const zoom2Coeff = computed(() => {
			return useScrollEffect(
				2.6 * windowHeight.value,
				3.5 * windowHeight.value,
				1,
				1.05
			);
		});

		const isShow = computed({
			get: () => {
				return props.isOpen;
			},
			set: (val) => {
				emit("changeContentStatus", val);
			},
		});
		const showContent = (val) => {
			isShow.value = !isShow.value;
			emit("changeShowIndex", val);
		};

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
			});
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (
					innerHeight.value > 0 &&
					innerHeight.value < 2.6 * windowHeight.value
				) {
					imgA.value.style.transform = `scale(${nv *
						zoomCoeff.value.a +
						zoomCoeff.value.b})`;
				}

				if (innerHeight.value > -0.2 * windowHeight.value) {
					mainTitle.value.style.opacity = `${nv * fadeInCoeff.a +
						fadeInCoeff.b}`;
					cover.value.style.opacity = `${nv * fadeInCoeff.a +
						fadeInCoeff.b}`;
				} else if (innerHeight.value <= -0.2 * windowHeight.value) {
					mainTitle.value.style.opacity = 0;
					cover.value.style.opacity = 0;
				}

				if (innerHeight.value > 1 * windowHeight.value) {
					mainTitle.value.style.opacity = `${-nv * fadeOutCoeff.a -
						fadeOutCoeff.b}`;
					cover.value.style.opacity = `${-nv * fadeOutCoeff.a -
						fadeOutCoeff.b}`;
				}

				if (
					innerHeight.value >= 1.3 * windowHeight.value &&
					innerHeight.value <= 2.4 * windowHeight.value
				) {
					if (!featureA1.value.classList.contains("rush-in")) {
						featureA1.value.classList.add("rush-in");
						featureA1.value.classList.remove("rush-out");
					}
					if (!featureA2.value.classList.contains("rush-in")) {
						featureA2.value.classList.add("rush-in");
						featureA2.value.classList.remove("rush-out");
					}
				} else {
					if (featureA1.value.classList.contains("rush-in")) {
						featureA1.value.classList.remove("rush-in");
						featureA1.value.classList.add("rush-out");
					}
					if (featureA2.value.classList.contains("rush-in")) {
						featureA2.value.classList.remove("rush-in");
						featureA2.value.classList.add("rush-out");
					}
				}

				if (
					innerHeight.value > 2 * windowHeight.value &&
					innerHeight.value < 2.6 * windowHeight.value
				) {
					imgB.value.style.opacity = `${nv * imgCoeff.value.a +
						imgCoeff.value.b}`;
				} else if (innerHeight.value <= 2 * windowHeight.value) {
					imgB.value.style.opacity = 0;
				} else {
					imgB.value.style.opacity = 1;
				}

				if (innerHeight.value >= 2.6 * windowHeight.value) {
					imgA.value.style.transform = "scale(1)";
					imgB.value.style.transform = `scale(${nv *
						zoom2Coeff.value.a +
						zoom2Coeff.value.b})`;
					featuresB.value.style.zIndex = 92;
					if (!featureB1.value.classList.contains("rush-in")) {
						featureB1.value.classList.add("rush-in");
						featureB1.value.classList.remove("rush-out");
					}
					if (!featureB2.value.classList.contains("rush-in")) {
						featureB2.value.classList.add("rush-in");
						featureB2.value.classList.remove("rush-out");
					}
				} else {
					featuresB.value.style.zIndex = 88;
					if (featureB1.value.classList.contains("rush-in")) {
						featureB1.value.classList.remove("rush-in");
						featureB1.value.classList.add("rush-out");
					}
					if (featureB2.value.classList.contains("rush-in")) {
						featureB2.value.classList.remove("rush-in");
						featureB2.value.classList.add("rush-out");
					}
				}
			}
		);

		return {
			container,
			windowWidth,
			imgSrcA,
			imgSrcB,
			imgA,
			imgB,
			cover,
			mainTitle,
			textCoeff,
			featuresA,
			featuresB,
			featureA1,
			featureA2,
			featureB1,
			featureB2,
			showContent,
		};
	},
};
</script>

<template>
	<section id="technology">
		<div class="bg_c4 sticky-wrapper" ref="container">
			<img
				:src="windowWidth > 992 ? imgSrcA.pc : imgSrcA.mobile"
				alt="G26全新BMW 4系列Gran Coupé豪華四門跑車 內裝科技 寬敞車室空間 iDrive 7.0全數位虛擬座艙"
				ref="imgA"
			/>
			<img
				class="imgB"
				:src="windowWidth > 992 ? imgSrcB.pc : imgSrcB.mobile"
				alt="G26全新BMW 4系列Gran Coupé豪華四門跑車 內裝科技 Personal CoPilot智慧駕駛輔助科技 BMW智慧語音助理2.0"
			/>
			<div
				class="f2_img"
				:style="{
					backgroundImage: `url(${
						windowWidth > 992 ? imgSrcB.pc : imgSrcB.mobile
					})`,
				}"
				ref="imgB"
			/>
			<div class="contain-img"></div>
			<div class="main-cover" ref="mainTitle">
				<h2 class="title_main text_ch_medium shine">
					<span class="inner_title_main">豪華智能 自有鋒</span>
					<span>格</span>
				</h2>
				<p class="title_sub text_ch_medium">
					<span
						>寬敞實用的舒適座艙，
						<br
							class="mobile_break"
						/>搭配領先車壇的智能科技，</span
					><br />
					<span>
						以直覺愜意的嶄新互動，享受隨心所欲的駕乘體驗。
					</span>
				</p>
			</div>
			<div class="cover" ref="cover"></div>
		</div>
	</section>
	<section id="technology-text">
		<div class="sticky-wrapper">
			<div class="features_A" ref="featuresA">
				<div
					class="feature feature_A-1 text_ch_heavy"
					@click="showContent(4)"
					ref="featureA1"
				>
					<p
						><span class="text_en_bold">iDrive 7.0 </span
						>全數位虛擬座艙</p
					>
					<span class="arrow_goto"></span>
				</div>
				<div
					class="feature feature_A-2 text_ch_heavy"
					@click="showContent(5)"
					ref="featureA2"
				>
					<p>寬敞車室空間</p>
					<span class="arrow_goto"></span>
				</div>
			</div>
			<div class="features_B" ref="featuresB">
				<div
					class="feature feature_B-1 text_ch_heavy"
					@click="showContent(6)"
					ref="featureB1"
				>
					<p
						><span class="text_en_bold">Personal CoPilot </span
						>智慧駕駛輔助科技</p
					>
					<span class="arrow_goto"></span>
				</div>
				<div
					class="feature feature_B-2 text_ch_heavy"
					@click="showContent(7)"
					ref="featureB2"
				>
					<p
						><span class="text_en_bold">BMW </span>智慧語音助理
						<span class="text_en_bold">2.0</span></p
					>
					<span class="arrow_goto"></span>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="sass" scoped>
$timing: cubic-bezier(0.83, 0, 0.17, 1)
$offset: 75px

#technology
    z-index: 57
    // z-index: 67
    background-color: #111
    .bg_c4
        width: 100%
        img
            position: absolute
            width: 100%
            height: 100%
            top: 0%
            // transform: translateY(-50%)
            object-fit: cover
        .imgB
            display: none
        .f2_img
            position: absolute
            left: 0
            top: 0
            width: 100%
            height: 100%
            background-size: cover
            background-repeat: no-repeat
            background-position: 0 center
            opacity: 0
            &::before
                content: ""
                position: absolute
                display: none
                width: 100%
                height: 58.3%
                left: 0px
                bottom: 0
                background-image: linear-gradient(to bottom, transparent 2%, rgba(#000, 0.9) 98%)
                background-repeat: no-repeat
        .contain-img
            display: none
            position: absolute
            width: 100%
            height: 20%
            bottom: 0px
            background-image: linear-gradient(to bottom, transparent 2%, #000 98%)
            background-position: center
            background-repeat: no-repeat
            z-index: 90
        .cover
            position: absolute
            width: 100%
            height: calc(100% + 60px)
            left: 0
            bottom: -5px
            opacity: 0
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 1))
        .main-cover
            position: relative
            width: 90%
            margin: 0 auto
            top: 70%
            z-index: 90
            text-align: center
            overflow: hidden
            h2
                position: relative
                width: 100vw
                left: 50%
                transform: translateX(-50%)
                text-align: center
                font-size: 3rem
                line-height: 2.83
                color: #999
                span
                    letter-spacing: normal
                    font-size: inherit
                    &.inner_title_main
                        letter-spacing: 15px
                &.shine
                        animation: shine 4s infinite linear forwards
            .title_sub
                position: relative
                margin-top: 10px
                font-size: 1.7rem
                line-height: 2.12
                letter-spacing: 3.06px
                text-align: center
                z-index: 70
                span
                    font-size: inherit
                .mobile_break
                    display: none

#technology-text
    width: calc(100% - 50px)
    z-index: 67
    .sticky-wrapper
        width: 100%
        .features_B
            z-index: 88
        .features_A, .features_B
            position: absolute
            width: 100%
            height: 100%
            z-index: 90
            top: 0
            .feature
                position: absolute
                cursor: pointer
                user-select: none
                transform: translateX(-15vw)
                opacity: 0
                transition: opacity 0.5s $timing, transform 0.5s $timing
                &.rush-in
                    opacity: 1
                    transform: translateX(0px)
                &.rush-out
                    opacity: 0
                    transform: translateX(-15vw)
                    transition: opacity 0.3s $timing, transform 0.3s $timing
                &::before
                    content: ""
                    position: absolute
                    display: block
                    width: 150px
                    height: 1px
                    left: -160px
                    top: 50%
                    transform: translateY(-50%)
                    background-image: linear-gradient(to right, transparent 2%, #fff 98%)
                    background-size: cover
                    background-repeat: no-repeat
                &::after
                    content: ""
                    position: absolute
                    display: block
                    width: 100%
                    height: 3px
                    left: 0px
                    bottom: 0
                    transform: translateY(-50%)
                    background-image: url("~@/assets/color-bar.png")
                    background-repeat: repeat-x
                    background-position: 0 0
                    animation: color-bar-loop 2.5s linear infinite forwards
                    background-size: 400px 6px
                p
                    display: inline-block
                    font-size: 1.8rem
                    line-height: 2.4
                    letter-spacing: 1.35px
                    vertical-align: middle
                    span
                        font-size: 1.5rem
                .arrow_goto
                    display: inline-block
                    vertical-align: middle
                    width: 14px
                    height: 32px
                    margin-left: 8px
                    background-image: url("~@/assets/launchImg/plus.png")
                    background-size: 30px 32px
                    background-position: center 4px
                    background-repeat: no-repeat
                    animation: nav_anim 2.5s ease infinite forwards
                &.feature_A-1
                    left: 68%
                    top: 28%
                    // top: 505.75px
                    &::before
                        width: 350px
                        left: -360px
                &.feature_A-2
                    left: 68%
                    top: 57%
                    // top: 646px
                    transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                    &::before
                        width: 1050px
                        left: -1060px
                    &.rush-out
                        transition: opacity 0.3s 0.15s $timing, transform 0.3s 0.15s $timing
                &.feature_B-1
                    left: 77%
                    top: 27%
                    &::before
                        width: 100px
                        left: -110px
                &.feature_B-2
                    left: 82%
                    top: 43%
                    transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                    &::before
                        width: 190px
                        left: -200px
                    &.rush-out
                        transition: opacity 0.3s 0.15s $timing, transform 0.3s 0.15s $timing

@media screen and (max-width: 1440px)
    #exterior-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    .arrow_goto
                        background-position: center 3px

@media screen and (max-width: 992px)
    #technology
        .bg_c4
            background-position: center
    #technology-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    &.feature_A-1
                        // left: 40%
                        left: calc(58.8vw - 186.4px)
                        top: calc(28% + 73.4% - 503.7px)
                        transform: translate(0px, $offset)
                        &.rush-in
                            transform: translate(0px, 0px)
                        &.rush-out
                            transform: translate(0px, $offset)
                        &::before
                            width: 1px
                            height: 120px
                            background-image: linear-gradient(to top, transparent 2%, #fff 98%)
                            left: 90%
                            top: calc(100% + 10px)
                            transform: translateX(-50%)
                    &.feature_A-2
                        // left: 78%
                        // top: 80%
                        left: calc(87.7vw - 96.3px)
                        top: calc(11.3vw + 567.9px + 73.4% - 623.7px)
                        transform: translate(0px, $offset)
                        &.rush-in
                            transform: translate(0px, 0px)
                        &.rush-out
                            transform: translate(0px, $offset)
                        &::before
                            width: 1px
                            height: 90px
                            background-image: linear-gradient(to top, transparent 2%, #fff 98%)
                            left: 50%
                            top: calc(100% + 10px)
                            transform: translateX(-50%)
                    &.feature_B-1
                        // left: 15%
                        // top: 85%
                        left: calc(19.3vw - 42.5px)
                        top: calc(8.9vw + 634.7px + 73.4% - 623.7px)
                        transform: translate(0px, $offset * -1)
                        transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                        &.rush-in
                            transform: translate(0px, 0px)
                        &.rush-out
                            transform: translate(0px, $offset * -1)
                            transition: opacity 0.5s 0.25s $timing, transform 0.5s 0.25s $timing
                        &::before
                            width: 1px
                            height: 170px
                            background-image: linear-gradient(to bottom, transparent 2%, #fff 98%)
                            left: 20%
                            top: -170px
                            transform: translateX(-50%)
                    &.feature_B-2
                        // left: 55%
                        // top: 8%
                        left: calc(61.7vw - 110.1px)
                        top: calc(-16.4vw + 231.1px + 73.4% - 553.7px)
                        transform: translate(0px, $offset)
                        transition: opacity 0.5s $timing, transform 0.5s $timing
                        &.rush-in
                            transform: translate(0px, 0px)
                        &.rush-out
                            transform: translate(0px, $offset)
                            transition: opacity 0.5s $timing, transform 0.5s $timing
                        &::before
                            width: 1px
                            height: 120px
                            background-image: linear-gradient(to top, transparent 2%, #fff 98%)
                            left: 20%
                            top: calc(100% + 10px)
                            transform: translateX(-50%)
@media screen and (max-width: 768px)
    #technology
        .bg_c4
            .f2_img
                &::before
                    display: block
            .main-cover
                .title_main
                    line-height: 2.22
                    span
                        font-size: 1.8rem
                        &.inner_title_main
                            letter-spacing: 10.8px
                .title_sub
                    font-size: 1.2rem
                    line-height: 2.08
                    letter-spacing: 1.44px
    #technology-text
        .sticky-wrapper
            .features_A, .features_B
                .feature
                    &::after
                        height: 2px
                    p
                        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.16)
                        font-size: 1.4rem
                        line-height: 2.57
                        letter-spacing: 0.7px
                        font-family: arudjingxiheipe1xg30_md, 微軟正黑體
                        span
                            font-size: inherit
                            font-family: "BMWTypeNextLatinTT-Thin", serif
                    .arrow_goto
                        width: 10px
                        height: 23px
                        margin-left: 5px
                        background-size: 21px 23px
                        background-position: center 2px

@media screen and (max-width: 650px)
    #technology
        .bg_c4
            background-size: 100% auto
            // background-position: center calc(50% - 20px)
            .contain-img
                display: block
            .main-cover
                // top: calc(2.6vw + 300px + 52.7% - 367px)
                top: 68%
                .title_sub
                    margin: 0
                    .pc_break
                        display: none
                    .mobile_break
                        display: block
            .cover
                height: 55%
                background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9) 76%)
    #technology-text
        .sticky-wrapper
            .text_minor, .text_title, .text_context
                top: 68%
            .text_minor
                line-height: 1.5
            .text_context
                margin-top: 10px
@media screen and (max-height: 600px)
    #technology
        .bg_c4
            .main-cover
                top: 63%
    #technology-text
        .sticky-wrapper
            .text_minor, .text_title, .text_context
                top: 65%
</style>
